import { AlignLeft, Bot, Check, CircleStop, Copy, Download, FileText, Menu, OctagonAlert, PanelLeft, PanelRight, Paperclip, RotateCcw, Send, Square, SquareDashed, StickyNote, ThumbsDown, ThumbsUp, Upload, User, X } from "lucide-react";
import {useEffect, useRef, useState} from "react";
import Button from "./Button";
import Input from "./Input";
import Help from "../constant/help";
import { useTranslation } from 'react-i18next';
import LanguageToggle from "./LanguageToggle";
import FileAttachment from "./FileAttachmentCard";
import removeMd from "remove-markdown";
import ChatAPI from "../api/chatApi";
import MarkdownMessage from "./MarkdownMessage";
import ReactMarkdown from "react-markdown";
import TypingEffectMarkdown from "./TypingEffectMarkdown";
import toast from "react-hot-toast";

export default function ChatPanel(props) {

    const {handleSend, chatContainerRef, messages, chatEndRef, input, setInput, selectedFileForChat, setActiveRightSection, handleSaveMessageToNote, handleLikeMessage, fileInputRef, handleRedoMessage, handleSendQuickQuestion, loadingConversations, currentChatId, setShowSidebar, setShowRightSidebar, showSidebar, setSelectedFileForChat, documentFiles, configChatweb, desktopSidebarCollapsed, setDesktopSidebarCollapsed, isFetchingChat} = props
    
    const { t } = useTranslation();
    const [copiedMessageId, setCopiedMessageId] = useState(null);

    const [quickQuestions, setQuickQuestions] = useState([]);

    const isLoadingConversation = loadingConversations?.[currentChatId] || false;
    
    const handleCopyMessage = async (messageId, content) => {
        try {
            const plainText = removeMd(content);
            await navigator.clipboard.writeText(plainText);

            // await navigator.clipboard.writeText(content);
            setCopiedMessageId(messageId);
            setTimeout(() => setCopiedMessageId(null), 3000);
        } catch (err) {
            console.error("Failed to copy text: ", err);
        }
    };

    const safeToISODate = (createdAt) => {
        try {
            if (!createdAt) return new Date().toISOString().slice(0, 10);

            // Firebase timestamp
            if (typeof createdAt === "object" && createdAt.time) {
            return new Date(createdAt.time).toISOString().slice(0, 10);
            }

            const d = new Date(createdAt);
            if (isNaN(d.getTime())) {
            return new Date().toISOString().slice(0, 10);
            }

            return d.toISOString().slice(0, 10);
        } catch {
            return new Date().toISOString().slice(0, 10);
        }
    };


    // const fetchRandomCTA = async () => {
    //     try {
    //         // const response = await ChatAPI.getRandomSuggestedQuestions("international-trade", 4)
    //         const response = await ChatAPI.getRandomSuggestedQuestions("international-trade", 4)
    //         console.log(response);
    //         setQuickQuestions(response)
    //         return response;
    //     } catch (error) {
    //         console.error("fetchRandomCTA: ", error);
    //     }
    // }
    // useEffect(() => {
    //     fetchRandomCTA()
    // }, [])
    const getRandomSuggestedQuestions = (arr, amount = 10) => {
        if (!Array.isArray(arr) || arr.length === 0) return [];
        
        const shuffled = [...arr].sort(() => 0.5 - Math.random());

        return shuffled.slice(0, amount);
    }

    useEffect(() => {
        if (configChatweb?.suggestedQuestions) {
            const randomQs = getRandomSuggestedQuestions(configChatweb.suggestedQuestions, 10);
            setQuickQuestions(randomQs);
        }
    }, [configChatweb]);
    console.log(quickQuestions);


    const handleDownloadBotMessage = async (msg) => {
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

        try {
            const dateStr = safeToISODate(msg.createdAt);

            const response = await ChatAPI.downloadBotReply(
            msg.message,
            dateStr
            );

            if (!response?.url) {
            throw new Error("No download url");
            }

            if (isMobile) {
            window.location.href = response.url;
            } else {
            const a = document.createElement("a");
            a.href = response.url;
            a.download = "";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            }

        } catch (error) {
            console.error("handleDownloadBotMessage:", error);
            toast.error(t('chatpanel.files.down_error'));
        }
    };

    messages.map((msg, idx) => {
        console.log(msg);
    })
    
  return (
    <div className='flex-1 flex flex-col h-screen'>
        <div className='bg-white border-b border-gray-200 p-4 flex items-center justify-between fixed top-0 left-0 right-0  z-50 md:static md:top-auto md:left-auto md:right-auto md:z-auto'
            style={{ height: '80px' }}>
            <div className='flex items-center justify-between w-full'>
                <div className="flex items-center space-x-2 sm:space-x-3">
                    {/* Nút mở Sidebar (mobile) */}
                    <button 
                        className="mr-1 sm:mr-2 block md:hidden"
                        onClick={() => {
                            if (window.innerWidth < 768) {
                                setShowSidebar((prev) => !prev);
                            }
                        }}
                    >
                        <Menu className="h-5 w-5 sm:h-6 sm:w-6 text-gray-600" />
                    </button>
                    
                    <div className="w-8 h-8 sm:w-10 sm:h-10 bg-sky-500 rounded-full flex items-center justify-center">
                        <Bot className="h-5 w-5 sm:h-6 sm:w-6 text-white cursor-pointer"
                            onClick={() => {
                                if (showSidebar) {
                                setShowSidebar(false);
                                }
                            }}/>
                    </div>
                    <div className="leading-tight">
                        <h2 className="font-semibold text-gray-900 text-sm sm:text-base truncate max-w-[140px] sm:max-w-none">
                            {configChatweb?.botName && configChatweb.botName.trim() !== ''
                                ? configChatweb.botName
                                : t('chatpanel.name_bot')}
                        </h2>
                        <p className="text-xs sm:text-sm text-green-600 flex items-center">
                            <span className="w-2 h-2 bg-green-500 rounded-full mr-1 sm:mr-2"></span>
                            {t('chatpanel.status_bot')}
                        </p>
                    </div>
                </div>
                {/* <LanguageToggle/> */}
                <div className="flex-shrink-0 ml-2">
                    <LanguageToggle />
                </div>
            </div>
            <div className="flex items-center space-x-2 pl-3">
                {/* Nút mở RightSidebar (tablet/mobile) */}
                <button className="xl:hidden" onClick={() => setShowRightSidebar(prev => !prev)}>
                    <PanelRight className="h-5 w-5 text-gray-600" />
                </button>
            </div>
        </div> 
        <div className='flex-1 overflow-y-auto p-4 pb-[130px] space-y-4 sm:px-4 mt-[80px] mb-0 md:mt-0 md:pb-4' ref={chatContainerRef}>
            {isFetchingChat ? (
                <div className="flex w-full h-full justify-center items-center mt-20">
                    <div className="w-8 h-8 border-4 border-sky-500 border-b-transparent rounded-full animate-spin"></div>
                </div>
            ) : messages.length === 0 ? 
            (
                <div className='max-w-4xl mx-auto mt-[130px] sm:mt-40 px-3 sm:px-6'>
                    {/* <div className='text-center mb-4'>
                        <h2 className='text-xl font-bold text-gray-500 mb-1'>
                            💬 {t('chatpanel.chat_welcome')}
                        </h2>
                        <p className='text-sm text-gray-600'>
                            {t('chatpanel.chat_question')}
                        </p>
                    </div> */}
                    <div className="text-center mb-4 px-2 sm:px-4">
                        <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-500 mb-1 leading-snug">
                            💬 {t('chatpanel.chat_welcome')}
                            {configChatweb?.botName && configChatweb.botName.trim() !== ''
                            ? configChatweb.botName
                            : t('chatpanel.name_bot')}
                        </h2>
                        <p className="text-xs sm:text-sm md:text-base text-gray-600 leading-relaxed">
                            {t('chatpanel.chat_question')}
                        </p>
                    </div>
                    <div className='flex flex-wrap justify-center gap-2 w-full'>
                        {quickQuestions.map((quick, index) => (
                                <Button
                                    key={index}
                                    variant="outline"
                                    size="sm_cta"
                                    onClick={() => handleSendQuickQuestion(quick)}
                                    className="text-gray-700 border border-gray-300 bg-white hover:bg-gray-50 hover:border-gray-400 rounded-full px-3 py-1 text-xs shadow-sm hover:shadow-md transition-all duration-300"
                                >
                                    {quick}
                                </Button>
                            )
                        )}
                    </div>
                </div>
            ) : (
                <>
                    {messages.map((msg, idx) => (
                        <div id={`message-index-${idx}`} key={msg.id || `msg-${idx}`} className={`flex w-full ${msg.isCustomer ? "justify-end" : "justify-start"}`}>
                        {!msg.isCustomer && (
                        <div className="flex flex-col max-w-[100%] md:flex-row gap-2 md:gap-3 mb-3">  
                            <div className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center bg-white border-2 border-sky-200 text-sky-600">
                                <Bot size={16} color="currentColor" />
                            </div>
                            
                            <div className="ml-3 md:pl-0 pr-4 py-3 relative group text-gray-800">
                                <div className="whitespace-pre-wrap text-sm leading-relaxed">
                                    {/* <MarkdownMessage>{Help.formatMessage(msg.message)}</MarkdownMessage> */}
                                    {/* <ReactMarkdown>{Help.formatMessage(msg.message)}</ReactMarkdown> */}
                                    
                                    {!msg.isHistorical ? (
                                        <TypingEffectMarkdown
                                            text={Help.formatMessage(msg.message)}
                                            speed={10}
                                            isStreaming={msg.isStreaming}
                                        />)
                                        :(<ReactMarkdown
                                            components={{
                                                a: ({node, ...props}) => (
                                                <a
                                                    {...props}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-blue-600 underline hover:text-blue-800 break-all max-w-full inline-block"
                                                />
                                                )
                                            }}
                                        >{Help.formatMessage(msg.message)}</ReactMarkdown>)
                                    }
                                </div>

                                <div className="text-xs mt-2 text-gray-500">{Help.formatTo24Hour(msg.createdAt)}</div>
                                    <div className="flex justify-between mt-3 pt-2 border-t border-gray-200 items-center">
                                        <div className="flex items-center space-x-1">
                                            {/* Like Button */}
                                            <Button
                                                variant="ghost"
                                                size="sm"
                                                onClick={() => handleLikeMessage(msg.id, 'like')}
                                                className={`h-8 w-8 p-0 transition-colors duration-200 ${msg.isLike === true
                                                    ? "text-green-600 bg-green-50 hover:bg-green-100"
                                                    : "text-gray-500 hover:text-green-600 hover:bg-green-50"
                                                }`}
                                            >
                                                <ThumbsUp className="h-4 w-4" />
                                            </Button>

                                            {/* Dislike Button */}
                                            <Button
                                                variant="ghost"
                                                size="sm"
                                                onClick={() => handleLikeMessage(msg.id, 'unlike')}
                                                className={`h-8 w-8 p-0 transition-colors duration-200 ${msg.isLike === false
                                                    ? "text-red-600 bg-red-50 hover:bg-red-100"
                                                    : "text-gray-500 hover:text-red-600 hover:bg-red-50"
                                                }`}
                                            >
                                                <ThumbsDown className="h-4 w-4" />
                                            </Button>

                                            {/* Add to Notes Button */}
                                            <Button
                                                variant="ghost"
                                                size="sm"
                                                onClick={() => handleSaveMessageToNote(msg)}
                                                className="h-8 w-8 p-0 text-gray-500 hover:text-yellow-600 hover:bg-yellow-50 transition-colors duration-200"
                                                title={t('chatpanel.title_note')}
                                            >
                                                <StickyNote className="h-4 w-4" />
                                            </Button>

                                            {/* Redo Button */}
                                            <Button
                                                variant="ghost"
                                                size="sm"
                                                onClick={() => handleRedoMessage(msg.id)}
                                                className="h-8 w-8 p-0 text-gray-500 hover:text-blue-600 hover:bg-blue-50 transition-colors duration-200"
                                                title={t('chatpanel.title_redo')}
                                            >
                                                <RotateCcw className="h-4 w-4" />
                                            </Button>

                                            {/* Share Button */}
                                            {/* <Button
                                                variant="ghost"
                                                size="sm"
                                                // onClick={() => handleShareMessage(message.id, textContent)}
                                                className={`h-8 w-8 p-0 transition-colors duration-200 text-gray-400 hover:text-blue-600 hover:bg-blue-50`}
                                                //     ${
                                                //     interaction?.shared ? "text-blue-600 bg-blue-50" : "text-gray-400 hover:text-blue-600 hover:bg-blue-50"
                                                // }`}
                                                title={t('chatpanel.title_share')}
                                            >
                                                <Share className="h-4 w-4" />
                                            </Button> */}

                                            {/* Copy Button */}
                                            <Button
                                                variant="ghost"
                                                size="sm"
                                                onClick={() => handleCopyMessage(msg.id, msg.message)}
                                                className={`h-8 w-8 p-0 transition-colors duration-200 text-gray-500 hover:text-gray-600 hover:bg-gray-50 ${copiedMessageId === msg.id ? "text-green-600 bg-green-50" : "text-gray-400 hover:text-gray-600 hover:bg-gray-50"}`}
                                                title={t('chatpanel.title_copy')}
                                            >
                                                {copiedMessageId === msg.id ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
                                            </Button>

                                            {/* Report Button */}
                                            {/* <Button
                                                variant="ghost"
                                                size="sm"
                                                // onClick={() => setShowReportDialog(message.id)}
                                                className={`h-8 w-8 p-0 transition-colors duration-200 text-gray-400 hover:text-orange-600 hover:bg-orange-50`}
                                                //     ${
                                                //     interaction?.reported
                                                //     ? "text-orange-600 bg-orange-50"
                                                //     : "text-gray-400 hover:text-orange-600 hover:bg-orange-50"
                                                // }`}
                                                title={t('chatpanel.title_report')}
                                            >
                                                <Flag className="h-4 w-4" />
                                            </Button> */}
                                            {/* Download reply */}
                                            <Button
                                                variant="ghost"
                                                size="sm"
                                                onClick={() => handleDownloadBotMessage(msg)}
                                                className={`h-8 w-8 p-0 transition-colors duration-200 text-gray-500 hover:text-purple-600 hover:bg-purple-50`}
                                                title={t('chatpanel.title_download')}
                                            >
                                                <Download className="h-3 w-3" />
                                            </Button>
                                        </div>
                                        {msg.mode === ' (Sáng tạo)' && (
                                            <div className="flex flex-wrap gap-1 mt-1">
                                                <span className="px-3 py-1 bg-sky-500 text-white text-xs rounded-3xl">
                                                    CHATGPT
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>)}
                            {msg.isCustomer && 
                            (
                                <div className="flex max-w-[85%] items-end gap-2 group ml-auto mb-2 mr-3">

                                    {/* Action bên trái */}
                                    <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity space-x-1">
                                    <Button
                                        variant="ghost"
                                        size="sm"
                                        onClick={() => handleSaveMessageToNote(msg)}
                                        className="h-6 w-6 p-0 text-gray-500 hover:text-yellow-600 hover:bg-yellow-50 transition-colors duration-200"
                                        title={t('chatpanel.title_note')}
                                    >
                                        <StickyNote className="h-4 w-4" />
                                    </Button>

                                    <Button
                                            variant="ghost"
                                            size="sm"
                                            onClick={() => handleCopyMessage(msg.id, msg.message)}
                                            className={`h-6 w-6 p-0 transition-colors duration-200 text-gray-500 hover:text-gray-600 hover:bg-gray-50 ${copiedMessageId === msg.id ? "text-green-600 bg-green-50" : "text-gray-400 hover:text-gray-600 hover:bg-gray-50"}`}
                                        >
                                            {copiedMessageId === msg.id ? <Check className="h-3 w-3" /> : <Copy className="h-4 w-4" />}
                                        </Button>
                                    </div>

                                    {/* Bubble */}
                                    <div className="rounded-xl px-3 py-2 text-sm bg-sky-500 text-white shadow-sm">
                                    <div className="whitespace-pre-wrap leading-relaxed">
                                        {msg.message}
                                    </div>
                                    {msg.attachments?.map((att, idx) => {
                                        if (att.type === "file") {
                                            return <FileAttachment key={idx} att={att} />;
                                        }
                                        return null;
                                    })}
                                    </div>
                                </div>
                            )
                            // (
                            // <div className="flex max-w-[80%] flex-row-reverse mr-3 mb-4 group">
                            //     <div className="rounded-2xl px-4 py-3 shadow-sm border relative group bg-sky-500 text-white border-sky-600">
                            //         <div className="whitespace-pre-wrap text-sm leading-relaxed">{msg.message}</div>
                            //         {msg.attachments?.map((att, idx) => {
                            //             if (att.type === "file") {
                            //                 return <FileAttachment key={idx} att={att} />;
                            //             }
                            //             return null;
                            //         })}
                                    
                            //         <div className="text-xs mt-2 text-sky-100">{Help.formatTo24Hour(msg.createdAt)}</div>

                            //         <div className="flex items-center space-x-1 mt-2 pt-2 border-t border-sky-200">
                            //             {/* Add to Notes Button for User Messages */}
                            //             <Button
                            //                 variant="ghost"
                            //                 size="sm"
                            //                 onClick={() => handleSaveMessageToNote(msg)}
                            //                 className="h-6 w-6 p-0 text-sky-200 hover:text-yellow-300 hover:bg-sky-600 transition-colors duration-200"
                            //                 title={t('chatpanel.title_note')}
                            //             >
                            //                 <StickyNote className="h-3 w-3" />
                            //             </Button>

                            //             {/* Copy Button for User Messages */}
                            //             <Button
                            //                 variant="ghost"
                            //                 size="sm"
                            //                 onClick={() => handleCopyMessage(msg.id, msg.message)}
                            //                 className={`h-6 w-6 p-0 transition-colors duration-200 text-sky-200 hover:text-sky-100 hover:bg-sky-600 ${copiedMessageId === msg.id ? "text-green-300 bg-sky-600" : "text-sky-200 hover:text-sky-100 hover:bg-sky-600"}`}
                            //                 title={t('chatpanel.title_copy')}
                            //             >
                            //                 {copiedMessageId === msg.id ? <Check className="h-3 w-3" /> : <Copy className="h-3 w-3" />}
                            //             </Button>
                            //         </div>
                            //     </div>
                            // </div>
                            // )
                            }
                        </div>
                    ))}
                </>
            )}
            
            {isLoadingConversation && (
                <div className="flex justify-start">
                    <div className="flex">
                        <div className="w-8 h-8 rounded-full bg-white border-2 border-sky-200 text-sky-600 mr-3 flex items-center justify-center">
                            <Bot className="h-4 w-4" />
                        </div>
                        <div className="bg-white border border-gray-200 rounded-2xl px-4 py-3 shadow-sm">
                            <div className="flex space-x-1">
                                <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"></div>
                                    <div
                                    className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
                                    style={{ animationDelay: "0.1s" }}
                                    ></div>
                                <div
                                    className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
                                    style={{ animationDelay: "0.2s" }}></div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <span ref={chatEndRef} className="h-6"></span>
        </div>
        <div className='bg-white border-t border-gray-200 p-4 fixed bottom-0 left-0 right-0 z-50 md:static md:bottom-auto md:left-auto md:right-auto md:z-auto min-h-[115px] h-auto flex flex-col justify-center' style={{ zIndex: 1 }}>
            {selectedFileForChat && (
                <div className="mb-3 p-2 bg-gray-50 rounded-lg border border-gray-200">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-2">
                        {/* <Upload className="h-4 w-4 text-gray-500" /> */}
                        {selectedFileForChat?.status === "uploading" ? (
                        <div className="w-4 h-4 border-2 border-gray-500 border-t-transparent rounded-full animate-spin" />
                            ) : selectedFileForChat?.status === "ready" ? (
                            <Upload className="h-4 w-4 text-gray-600" />
                            ) : (
                            <OctagonAlert className="h-4 w-4 text-gray-600" />
                        )}
                        <span className="text-sm text-gray-600">
                           {decodeURIComponent(selectedFileForChat.title)}
                        </span>
                        {/* <span className="text-sm text-gray-600">
                           {Help.getFileNameFromUrl(selectedFileForChat.url)}
                        </span> */}
                        
                        {/* {selectedFileForChat && (
                            <span className="px-2 py-1 bg-violet-100 text-violet-700 text-xs rounded-full">
                            {t('chatpanel.file_selected')}
                            </span>
                        )} */}
                        {selectedFileForChat?.status === "uploading" && (
                            <span className="px-2 py-1 bg-violet-100 text-violet-700 text-xs rounded-full">Đang tải lên...</span>
                            )}
                        {selectedFileForChat?.status === "ready" && (
                            <span className="px-2 py-1 bg-violet-100 text-violet-700 text-xs rounded-full"> {t('chatpanel.file_selected')}</span>
                        )}
                        {selectedFileForChat?.status === "failed" && (
                            <span className="text-xs text-red-600 ml-1">Tải thất bại</span>
                        )}
                        </div>
                        <Button
                            variant="ghost"
                            size="sm"
                            className="text-gray-500 hover:text-gray-700"
                            onClick={() => {
                                setSelectedFileForChat(null);   
                                setInput("");
                            }}
                        >
                            <X className="h-4 w-4" />
                        </Button>
                    </div>
                </div>
            )}
            <form className="flex items-end space-x-2 sm:space-x-3 px-2 sm:px-0" onSubmit={(e) => {
                e.preventDefault();
                handleSend();
            }}>
                <div className="flex-1">
                    <div className="relative bg-gray-50 rounded-2xl border border-gray-300 focus-within:border-sky-400 focus-within:bg-white transition-all duration-200">
                        <Input
                            value={input}
                            onChange={(e) => setInput(e.target.value)}
                            placeholder={t('chatpanel.input_placeholder')}
                            className="border-0 bg-transparent rounded-2xl px-4 py-3 pr-20 focus:ring-0 focus:outline-none resize-none">
                        </Input>
                        <div className="absolute right-2 top-1/2 transform -translate-y-1/2 flex items-center space-x-1">
                            {/* <Button 
                                type="button"
                                variant="ghost"
                                size="sm"
                                className="h-8 w-8 p-0 text-gray-400 hover:text-gray-600"
                            >
                                <Smile className="h-4 w-4"/>
                            </Button> */}
                            {selectedFileForChat?.status === "uploading" ? 
                                (
                                    <div className="w-4 h-4 border-2 border-gray-500 border-t-transparent rounded-full animate-spin mr-2" />
                                ):
                                (
                                    <Button
                                        type="button"
                                        variant="ghost"
                                        size="sm"
                                        className="h-8 w-8 p-0 text-gray-400 hover:text-gray-600"
                                        onClick={() => fileInputRef?.current?.click()}
                                    >
                                        <Paperclip className="h-4 w-4" />
                                    </Button>
                                )
                            }
                        </div>
                    </div>
                </div>
                <Button
                    type="submit"
                    disabled={!input.trim() || isLoadingConversation || (messages && messages.some(msg => msg.isStreaming))}
                    className="h-12 w-12 bg-sky-500 hover:bg-sky-600 text-white rounded-full border-0 shadow-md hover:shadow-lg transition-all duration-300 flex-shrink-0"
                >
                    {(isLoadingConversation || (messages && messages.some(msg => msg.isStreaming))) ? (
                        <Square className="h-3 w-3"/>
                    ) : (
                        <Send className="h-5 w-5" />
                    )}
                </Button>
            </form>
            <p 
                className="text-xs text-gray-500 mt-2 text-center whitespace-nowrap"
                // className="text-[12px] sm:text-xs text-gray-500 mt-2 text-center px-2"
            >
                {configChatweb?.botName && configChatweb.botName.trim() !== ''
                ? configChatweb.botName
                : 'VietradeAI'}
                {t('chatpanel.note_info')}
            </p>
        </div>

    </div>
  );
}
